import React from 'react'


const createConfigurationOptions = {
    fields: {
        username: {
            type: 'login',
            error: <i>Please enter username</i>
        },
        password: {
            type: 'password',
            error: <i>Please enter password</i>
        }
    }
}

export default createConfigurationOptions


// WEBPACK FOOTER //
// ./src/screens/login/components/forms/Login/options.js